import React, { useRef, useEffect } from "react"
import { MapPin, Clock, Archive } from "react-feather"
import Components from "../.."
import CareerJobApplyBtn from "./CareerJobApplyBtn"
import { CareerHeaderItemProps, CareerJobDetailsProps } from "./CareerJobTypes"
import { StyledCareerJobBackButton, StyledCareerJobHeaders, StyledHeaderItem } from "./CareersJobStyles"

const HeaderItem = ({ children, title }: CareerHeaderItemProps) => (
  <StyledHeaderItem>
    {children}
    <p>{title}</p>
  </StyledHeaderItem>
)

const CareerJobDetails = ({ back_button, jobDetails }: CareerJobDetailsProps) => {

  const {
    jobTitle,
    locationName,
    jobType,
    jobExperienceLevel,
    categories,
    jobDescription,
    jobApplyUrl
  } = jobDetails

  const backButton = back_button &&
    back_button.map((content) =>
      React.createElement(Components(content.component), {
        key: content._uid,
        blok: content,
        className: "btn--reverse btn--sm-wide",
      })
    )

    const descriptionRef = useRef(null);
    useEffect(() => {
      if (descriptionRef.current){
        descriptionRef.current.innerHTML = jobDescription.replace(/<\/?span[^>]*>/g, "")
      }
    }, [jobDescription])

  return (
    <div className="job">
      <StyledCareerJobBackButton>
        {backButton}
      </StyledCareerJobBackButton>
      <p className="job__title title__h1">{jobTitle}</p>
      <StyledCareerJobHeaders>
        <HeaderItem
          title={locationName}
          children={<MapPin className="job__header-icon" />}
        />
        <HeaderItem
          title={jobType ? `${jobType} - ${jobExperienceLevel}` : jobExperienceLevel}
          children={<Clock className="job__header-icon" />}
        />
      </StyledCareerJobHeaders>
      <HeaderItem
        title={categories.map(cat => cat).join(", ")}
        children={<Archive className="job__header-icon" />}
      />
      <section className="section">
        <p ref={descriptionRef}></p>
      </section>
      <CareerJobApplyBtn url={jobApplyUrl} />
    </div>
  )
}

export default CareerJobDetails